	export enum PaymentTypeEnum {
		Insurance = 1,
		Patient = 2,
		Refund = 3,
		Adjustment = 4
	}
